import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { IReportFilter } from '../../../utils/interfaces/report-filter';
import { IResponse } from '../../../utils/interfaces/response';
import {
  IWordCloud,
  IWordCloudSearch,
} from '../../../utils/interfaces/word-cloud';

@Injectable({
  providedIn: 'root',
})
export class WordCloudReportService {
  private readonly URI_API = environment.apiConfig.uri + 'WordCloudReport';

  constructor(private readonly httpClient: HttpClient) {}

  getWordCloudReport(filter: IReportFilter): Observable<IResponse<IWordCloud>> {
    return this.httpClient
      .post<IResponse<IWordCloud>>(`${this.URI_API}/wordcloud`, filter)
      .pipe(
        map((res) => {
          res.data.wordCloud.sort((a, b) => b.weight - a.weight);
          return res;
        })
      );
  }

  getWordCloudSearchReport(
    filter: IReportFilter,
    searchFilter: {
      searchString: string | null;
      page: number;
      take: number;
      asc: boolean;
      status: boolean;
      branchesId: string[];
      startDate?: string;
      finishDate?: string;
      startTime?: string;
      finishTime?: string;
    }
  ): Observable<IResponse<IWordCloudSearch>> {
    return this.httpClient.post<IResponse<IWordCloudSearch>>(
      `${this.URI_API}/words?pollId=${filter.pollId}`,
      searchFilter
    );
  }
}
